var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"page-move","css":false,"mode":"out-in"},on:{"enter":_vm.pageEnter,"leave":_vm.pageLeave}},[_c('keep-alive',{attrs:{"include":"magazineList"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }